export function disclaimer() {
  return `Refrain from posting comments that are obscene, defamatory or inflammatory,
			 and do not indulge in personal attacks, name calling or inciting hatred
			 against any community. Help us delete comments that do not follow these
			 guidelines by marking them offensive. Let's work together to keep the
			 conversation civil.`;
}
export default { disclaimer };
